import { FC } from "react";
import BannerCard from "@Components/BannerCard/BannerCard";
import PersonalSummary from "@Components/PersonalSummary/PersonalSummary";
import { NextArrowIcon } from "@Icons/MainIcons";
import { useTranslation } from "react-i18next";

const PassengerSummaryTrigger: FC<{ passengerItems: any[]; onClick?: () => void }> = ({ passengerItems, onClick }) => {
  const { t } = useTranslation();

  return (
    <div
      className="rounded-xs! flex cursor-pointer justify-between p-4 shadow-sm bg-background-default"
      onClick={onClick}
    >
      <PersonalSummary
        title={<div className="font-semibold text-lg">{t("Flights.details.summary.passengerDetails")}</div>}
        items={passengerItems}
        nameOverflowCount={1}
        imgOverflowCount={2}
        classNames={{
          chipTitle: "font-semibold! text-sm!",
          root: "gap-2!",
          chipInfo: "gap-0.5!",
        }}
        chipSubtitle={(items) => (
          <div className="font-semibold! text-[.65rem]">
            {items.length === 1 ? t("Flights.details.summary.onePassenger") : t("Flights.details.summary.passengersCount", { count: items.length })}
          </div>
        )}
      />
      <div className="text-icon-disabled">
        <NextArrowIcon className="w-3" />
      </div>
    </div>
  );
};

export default PassengerSummaryTrigger;
